<template>
  <b-modal
    id="time-adding-child-info-modal"
    ref="time-adding-child-info-modal"
    body-class="p-10"
    centered
    :title="modalTitleText"
    content-class="p-2"
    no-close-on-backdrop
    hide-header
    hide-footer
    @hidden="resetModal"
    @show="openModal"
  >
    <div>
      <h2 class="info-modal-title">{{ modalTitleText }}</h2>

      <div class="info-modal-buttons w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="outline-primary"
          @click="skipForNow"
        >
          {{ skipButtonText }}
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="addNewChild"
        >
          {{ addButtonText }}
        </b-button>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="outline-primary"
          @click="skipForNow"
        >
          {{ skipButtonText }}
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="addNewChild"
        >
          {{ addButtonText }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { instanceSessionCamperNames } from '@core/mixins/instanceSessionCamperNames'
import { prepareProgramRegistrationInfo } from '@core/mixins/prepareProgramRegistrationInfo'
export default {
  components: {
    BModal,
    BButton,
  },
  mixins: [instanceSessionCamperNames, prepareProgramRegistrationInfo],
  computed: {
    ...mapGetters({
      authSettings: 'authSettings/getAuthSettings',
    }),
    modalTitleText() {
      return this.getCustomText(
        this.authSettings,
        'adding_child_modal_title',
        'Time to add your first {camperStudent}',
        { camperStudent: this.camperStudent('singular') },
      )
    },
    skipButtonText() {
      return this.getCustomText(this.authSettings, 'adding_child_modal_skip_button', 'Skip For Now')
    },
    addButtonText() {
      return this.getCustomText(this.authSettings, 'adding_child_modal_add_button', 'Add')
    },
  },
  methods: {
    resetModal() {},
    openModal() {},
    addNewChild() {
      this.$bvModal.hide('time-adding-child-info-modal')
      this.$emit('add-new-child')
    },
    skipForNow() {
      this.$bvModal.hide('time-adding-child-info-modal')
      this.$emit('skip')
    },
  },
}
</script>

<style lang="scss" scoped>
  .info-modal-title {
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 30px;
  }

  .info-modal-buttons {
    padding: 0 30px;
  }
</style>